<!-- <p>time-picker works!</p> -->
<div [ngStyle]="style" class="time-picker-container">
  <mat-card class="time-picker-card">
    <mat-card-header
      [ngClass]="{
        'time-picker-card-header':
          screenInfo == ScreenType.Desktop || screenInfo == ScreenType.Tablet,
        'time-picker-card-header-mobile': screenInfo == ScreenType.Mobile
      }"
      >{{ selectedDate | date : "fullDate" }}
    </mat-card-header>
    <mat-card-content class="time-picker-card-content"
      ><div *ngIf="isLoading" [ngStyle]="styleTable" class="timeslot-loader">
        <mat-spinner></mat-spinner>
      </div>
      <div *ngIf="error" [ngStyle]="styleTable" class="timeslot-loader">
        {{ error }}
      </div>
      <div
        *ngIf="!isLoading && !error && screenInfo != ScreenType.Mobile"
        [ngStyle]="styleTable"
        class="timeslot-table"
      >
        <table
          mat-table
          [dataSource]="
            (selectedDate | date) == (todayDate | date)
              ? filteredDataSource
              : dataSource
          "
        >
          <ng-container matColumnDef="no">
            <th mat-header-cell *matHeaderCellDef>No.</th>
            <td mat-cell *matCellDef="let element; let i = index">
              {{ i + 1 }}
            </td>
          </ng-container>
          <ng-container matColumnDef="time">
            <th mat-header-cell *matHeaderCellDef>Choose Time-Slot</th>
            <td mat-cell *matCellDef="let element">
              {{ element.time | date : "hh:mm a" }}
            </td>
          </ng-container>
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
              <mat-radio-button
                (change)="radioChange(element)"
                value="time"
              ></mat-radio-button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
      <div *ngIf="!isLoading && !error && screenInfo == ScreenType.Mobile">
        <app-mobile-table-card
          [timeSlotsTableData]="
            (selectedDate | date) == (todayDate | date)
              ? filteredDataSource
              : dataSource
          "
          [tableType]="'timeslots'"
          (showDetails)="radioChange($event)"
        ></app-mobile-table-card>
      </div> </mat-card-content
  ></mat-card>
</div>
